import React, {Component} from "react";
import PropTypes from "prop-types";
import {shallowEqual} from "recompose";
import Dropzone from "react-dropzone";
import {connect} from "react-redux";
import FileInputPreview from "./FileInputPreview";
import {translate} from "admin-on-rest";
import {BMTheme} from "../../BMTheme";

const defaultStyle = {
  dropZone: {
    background: BMTheme.fileInput.dropZone.backgroundColor,
    cursor: "pointer",
    padding: "1rem",
    textAlign: "center",
    color: BMTheme.fileInput.dropZone.color
  },
  preview: {
    float: "left"
  }
};

const formStyle = {
  validationStyle: {
    color: BMTheme.formValidation.color,
    fontSize: "80%"
  }
};

export class FileInput extends Component {
  static propTypes = {
    accept: PropTypes.string,
    children: PropTypes.element,
    disableClick: PropTypes.bool,
    elStyle: PropTypes.object,
    input: PropTypes.object,
    itemStyle: PropTypes.object,
    labelMultiple: PropTypes.string,
    labelSingle: PropTypes.string,
    maxSize: PropTypes.number,
    minSize: PropTypes.number,
    multiple: PropTypes.bool,
    removeStyle: PropTypes.object,
    style: PropTypes.object,
    translate: PropTypes.func.isRequired,
    placeholder: PropTypes.node
  };

  static defaultProps = {
    addLabel: true,
    addField: true,
    itemStyle: {},
    labelMultiple: "aor.input.file.upload_several",
    labelSingle: "aor.input.file.upload_single",
    multiple: false,
    onUpload: () => {},
    removeStyle: {display: "inline-block"}
  };

  constructor(props) {
    super(props);
    let files = props.input.value || [];
    if (!Array.isArray(files)) {
      files = [files];
    }

    this.state = {
      files: files.map(this.transformFile)
    };
  }

  componentWillReceiveProps(nextProps) {
    let files = nextProps.input.value || [];
    if (!Array.isArray(files)) {
      files = [files];
    }

    this.setState({files: files.map(this.transformFile)});
  }

  onDrop = files => {
    const updatedFiles = this.props.multiple
      ? [...this.state.files, ...files.map(this.transformFile)]
      : [...files.map(this.transformFile)];

    const file = files.find(f => f);
    const i = new Image();

    i.onload = () => {
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.setState({
          width: i.width,
          height: i.height
        });

        const validHeight = String(this.props.validHeight);
        const validWidth = String(this.props.validWidth);

        const w = String(this.state.width);
        const h = String(this.state.height)
        const validSize =  w === validWidth &&  h === validHeight

        if (validSize) {
          this.setState({files: updatedFiles});
          this.props.input.onChange(updatedFiles);
        }
      };
    };

    if (file) {
      i.src = file.preview;
    }
  };

  onRemove = file => () => {
    const filteredFiles = this.state.files.filter(
      stateFile => !shallowEqual(stateFile, file)
    );

    this.setState({files: filteredFiles});
    this.props.input.onChange(filteredFiles);
  };

  // turn a browser dropped file structure into expected structure
  transformFile = file => {
    if (!(file instanceof File)) {
      return file;
    }

    const {source, title} = React.Children.toArray(
      this.props.children
    )[0].props;

    const transformedFile = {
      rawFile: file,
      [source]: file.preview
    };

    if (title) {
      transformedFile[title] = file.name;
    }

    return transformedFile;
  };

  label() {
    const {translate, placeholder, labelMultiple, labelSingle} = this.props;

    if (placeholder) {
      return placeholder;
    }

    if (this.props.multiple) {
      return <p>{translate(labelMultiple)}</p>;
    }

    return <p>{translate(labelSingle)}</p>;
  }

  render() {
    const {
      accept,
      children,
      disableClick,
      itemStyle,
      maxSize,
      minSize,
      multiple,
      style,
      removeStyle,
      validHeight,
      validWidth
    } = this.props;

    const finalStyle = {
      ...defaultStyle,
      ...style
    };
    const reduxErrors = {...this.props.errors};
    const errors = {...reduxErrors.syncErrors};

    const validSize = (width, height, validWidth, validHeight) => {
      return String(width) === String(validWidth) && String(height) === String(validHeight)
    }

    const imgError = (width, height, validWidth, validHeight, reduxErrors) => {
      const res = width && height && !validSize(width, height, validWidth, validHeight) && (reduxErrors.anyTouched || reduxErrors.submitFailed) && (
              <span style={formStyle.validationStyle}>
                {this.props.translate(
                  "resources.promos.validation.requiredImageDimensions.small",
                  {dimensions: validWidth + " x " + validHeight}
                )}
                <br />
                {this.props.translate(
                  "resources.promos.validation.requiredImageDimensions.current"
                ) +
                  width +
                  " x " +
                  height +
                  ")"}
              </span>
            )
      return res;
    }
    
    return (
      <div>
        <Dropzone
          onDrop={this.onDrop}
          accept={accept}
          disableClick={disableClick}
          maxSize={maxSize}
          minSize={minSize}
          multiple={multiple}
          style={finalStyle.dropZone}
        >
          {this.label()}
        </Dropzone>
        {children && (
          <div className="previews">
            {this.state.files.map((file, index) => (
              <FileInputPreview
                key={index}
                file={file}
                itemStyle={itemStyle}
                onRemove={this.onRemove(file)}
                removeStyle={removeStyle}
              >
                {React.cloneElement(children, {
                  record: file,
                  style: defaultStyle.preview
                })}
              </FileInputPreview>
            ))}
          </div>
        )}

        {(reduxErrors.anyTouched || reduxErrors.submitFailed) &&
          (errors.images || errors.web_offer_style) &&
          this.state.files.length === 0 &&
          ((String(this.state.width) === "undefined" &&
            String(this.state.height) === "undefined") ||
            (String(this.state.width) === validWidth &&
              String(this.state.height) === validHeight)) && (
            <span style={formStyle.validationStyle}>
              {this.props.translate(
                "resources.promos.validation.requiredImage"
              )}
            </span>
          )}

        {this.props.source === "web_offer_style.logo" ? imgError(this.state.width, this.state.height, validWidth, validHeight, reduxErrors) : null}
        {this.props.source === "images.large"
          ? this.state.width &&
            this.state.height &&
            (reduxErrors.anyTouched || reduxErrors.submitFailed) &&
            String(this.state.width) !== String(validWidth) &&
            String(this.state.height) !== String(validHeight) && (
              <span style={formStyle.validationStyle}>
                {this.props.translate(
                  "resources.promos.validation.requiredImageDimensions.large",
                  {dimensions: validWidth + " x " + validHeight}
                )}
                <br />
                {this.props.translate(
                  "resources.promos.validation.requiredImageDimensions.current"
                ) +
                  this.state.width +
                  " x " +
                  this.state.height +
                  ")"}
              </span>
            )
          : this.props.source === "images.small" &&
            this.state.width &&
            this.state.height &&
            (reduxErrors.anyTouched || reduxErrors.submitFailed) &&
            String(this.state.width) !== String(validWidth) &&
            String(this.state.height) !== String(validHeight) && (
              <span style={formStyle.validationStyle}>
                {this.props.translate(
                  "resources.promos.validation.requiredImageDimensions.small",
                  {dimensions: validWidth + " x " + validHeight}
                )}
                <br />
                {this.props.translate(
                  "resources.promos.validation.requiredImageDimensions.current"
                ) +
                  this.state.width +
                  " x " +
                  this.state.height +
                  ")"}
              </span>
            )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    errors: state.form[`record-form`]
  };
};

export default connect(mapStateToProps)(translate(FileInput));



// WEBPACK FOOTER //
// ./src/components/CRM/FileInput.js